import { useCallback, useId } from 'react';
import { useIntl } from 'react-intl';

import type { DossierStatutFilterOption } from '../../utils/dossierStatut';
import {
  $StatusFilter,
  $StatusFilterLabel,
  $StatusFilterSelect,
} from './DossierStatusFilter.styles';
import messages from './messages';

export interface DossierStatusFilterProps {
  options: DossierStatutFilterOption[];
  selectedStatut: string | undefined;
  onSelectStatut: (statut: string | undefined) => void;
  dataTestId?: string;
}

const DossierStatusFilter = ({
  options,
  selectedStatut,
  onSelectStatut,
  dataTestId = 'dossier-status-filter',
}: DossierStatusFilterProps) => {
  const intl = useIntl();
  const selectId = useId();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const { value } = event.target;

      onSelectStatut(value === '' ? undefined : value);
    },
    [onSelectStatut],
  );

  return (
    <$StatusFilter data-testid={dataTestId}>
      <$StatusFilterLabel htmlFor={selectId}>
        {intl.formatMessage(messages.label)}
      </$StatusFilterLabel>
      <$StatusFilterSelect
        id={selectId}
        value={selectedStatut ?? ''}
        onChange={handleChange}
        data-testid={`${dataTestId}-select`}
      >
        <option value="">{intl.formatMessage(messages.all)}</option>
        {options.map((option) => (
          <option key={option.statut} value={option.statut}>
            {option.statut}
          </option>
        ))}
      </$StatusFilterSelect>
    </$StatusFilter>
  );
};

export default DossierStatusFilter;
